// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export enum customerEndpoints {
  TerpDev = "http://api.eplanner.eliteit.dk/",
  TerpTest = "https://api-terp-eplanner.eliteit.dk/",
  EliteitProd = "http://api.eiplanner.eliteit.dk/",
  Local = "http://localhost:62598/",
}


export enum productModels {
  Lite = 1,
  Premium = 2,
  Maintenance= 3
}

export const environment = {
  production: false,
  // Terp Test
  //endPointApiUrl: "https://api-terp-eplanner.eliteit.dk/",
  //endPointApiUrl: "http://api.eplanner.eliteit.dk/",
  //endPointApiUrl: "http://api.eiplanner.eliteit.dk/",
  //endPointApiUrl: "http://localhost:62699/",

  endPointApiUrl: "http://localhost:62598/",
  projectVersion: "20.0.0",



  // Lite | Premium
  productModel: productModels.Lite,
  //productModel: productModels.Premium,

  DEFAULT_DATETIME_FULL: "0001-01-01T00:00:00",
  DEFAULT_DATETIME_START: "0001-01-01",
  DEFAULT_DATETIME_END: "00:00:00",
  FULL_DATETIME_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  START_DATETIME_FORMAT: "YYYY-MM-DD",
  END_DATETIME_FORMAT: "HH:mm:ss",

  START_DATETIME_FORMAT_DANISH: "DD-MM-YYYY",
  FULL_DATETIME_FORMAT_DANISH: "DD-MM-YYYY HH:mm:ss",

  DEFAULT_DATETIME_START_DANISH: "01-01-0001",

  SCHEDULER_TOKEN: "CC-Attribution-NonCommercial-NoDerivatives"
};











// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/environments/environment.ts